import {
    SET_ENTRANCE_ID, SET_ENTRANCE_STATUS, SET_VERIFIED_ENTRANCE,
    SET_SELECTED_RESIDENT, SET_SEARCH_QUERY, SET_NOTICE, RESET,
} from './actions';
import { QR_ENTRANCE_STATUS } from '../../constants/qr';
import initialState from './state';

export default {
    [SET_ENTRANCE_ID]: (state, payload) => {
        state.entranceId = payload;
    },

    [SET_ENTRANCE_STATUS]: (state, payload) => {
        state.entranceStatus = payload;
    },

    [SET_VERIFIED_ENTRANCE]: (state, payload) => {
        const { offices = [], ...intercom } = payload;
        state.intercom = { ...intercom };
        state.offices = offices;
        state.entranceStatus = QR_ENTRANCE_STATUS.SUCCESS;
    },

    [SET_SELECTED_RESIDENT]: (state, { id, displayName, badgeColor }) => {
        state.selectedResident = { id, displayName };
        if (badgeColor) state.selectedResident.badgeColor = badgeColor;
    },

    [SET_SEARCH_QUERY]: (state, payload) => {
        state.searchQuery = payload || '';
    },

    [SET_NOTICE]: (state, payload) => {
        state.notice = payload || null;
    },

    [RESET]: state => {
        Object.assign(state, initialState());
    },
};
